import { keyBy } from 'lodash';

export const matchGridColumns = keyBy([
    {
        suppressMenu: true,
        field: 'id',
        headerName: 'ID',
        type: 'numericColumn',
        sortable: true,
        filter: 'agNumberColumnFilter'
    },
    {
        suppressMenu: true,
        field: 'source',
        editable: true,
        sortable: true,
        filter: 'agTextColumnFilter',
        cellStyle: { "white-space": "normal" },
        cellEditor: 'agTextCellEditor',
        headerName: 'Source'
    },
    {
        suppressMenu: true,
        field: 'source_product_id',
        headerName: 'Source Prod ID',
        sortable: true,
        filter: 'agTextColumnFilter',
        cellStyle: { "white-space": "normal" }
    },
    {
        suppressMenu: true,
        field: 'source_product',
        headerName: 'Source Product',
        editable: true,
        sortable: true,
        filter: 'agTextColumnFilter',
        cellStyle: { "white-space": "normal" },
        cellEditor: 'agTextCellEditor'
    },
    {
        suppressMenu: true,
        field: 'source_size',
        headerName: 'Source Size',
        editable: true,
        sortable: true,
        filter: 'agTextColumnFilter',
        cellEditor: 'agTextCellEditor'
    },
    {
        suppressMenu: true,
        field: 'source_upc',
        headerName: 'UPC',
        sortable: true,
        minWidth: 150,
        filter: 'agTextColumnFilter',
        cellRenderer: 'cellWithCopyButton',
        cellStyle: { "white-space": "normal" }
    },
    {
        suppressMenu: true,
        field: 'sizer',
        headerName: 'Sizer',
        sortable: true,
        filter: 'agTextColumnFilter'
    },
    {
        suppressMenu: true,
        field: 'product_id',
        headerName: 'Product ID',
        editable: true,
        cellEditor: 'agTextCellEditor',
        type: 'numericColumn',
        sortable: true,
        filter: 'agNumberColumnFilter'
    },
    {
        suppressMenu: true,
        field: 'good',
        headerName: 'Good',
        editable: true,
        sortable: true,
        minWidth: 30,
        filter: 'agNumberColumnFilter',
        type: 'numericColumn',
        cellEditor: 'agSelectCellEditor',
        cellEditorParams: { values: [-1, 0, 1, 2] }
    },
    {
        suppressMenu: true,
        field: 'create_date',
        headerName: 'Created',
        sortable: true,
        filter: 'agDateColumnFilter'
    },
    {
        suppressMenu: true,
        field: 'last_mod',
        headerName: 'Last Modified',
        sortable: true,
        filter: 'agDateColumnFilter'
    }
], 'field');